import { classNames } from 'shared/lib/utils/classNames';
import { Button } from 'shared/ui/Button';
import { IconWrapper } from 'shared/ui/IconWrapper';
import { Text } from 'shared/ui/Text';

import { MenuGroup } from '../../hooks/menu.types';
import cls from './NavigationGroups.module.scss';

type NavigationGroupsProps = {
  groups: MenuGroup[];
  currentGroup: string;
  handleChangeGroup: (group: MenuGroup) => void;
};

export function NavigationGroups(props: NavigationGroupsProps) {
  const { groups, currentGroup, handleChangeGroup } = props;

  return (
    <div className={cls.Wrapper}>
      {groups.map((group) =>
        !group.disabled ? (
          <Button
            variant='text'
            key={group.title}
            className={classNames(cls.Item, {
              [cls.Active]: currentGroup === group.title,
            })}
            onClick={() => handleChangeGroup(group)}
            onKeyDown={(e) => {
              if (e.code === 'Enter') handleChangeGroup(group);
            }}
          >
            <IconWrapper
              icon={group.icon}
              color='var(--ucr-palette-icon-white)'
            />

            <Text variant='b1' className={cls.NavGroupTitle}>
              {group.title}
            </Text>
          </Button>
        ) : (
          <Button
            variant='text'
            key={group.title}
            disabled
            className={cls.Item}
          >
            <IconWrapper icon={group.icon} />

            <Text variant='b1'>{group.title}</Text>
          </Button>
        ),
      )}
    </div>
  );
}
